<template>
    <div class="inner-box">
        <!-- AS 접수제품 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS접수제품` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray" @click="openModel">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        모델선택
                        </button>
                        <button class="btn-size btn-gray" @click="deleteRow(1)">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :context="context"
                            :column-defs="columnDefs"
                            :grid-options="mainGridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            @cell-value-changed="MaincellValueChange"
                            @cell-clicked="onMainCellClicked"
                            editType="fullRow" />
                    </div>
                </div>
            </div>
        </div>
        <!-- AS 접수제품 그리드 e.-->
        <!-- 고장증상 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `고장증상` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="breakOpenModal">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        추가
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="deleteRow(2)">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    </div>
                    
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="subGrid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            :stopEditingWhenCellsLoseFocus="true"
                            @cell-value-changed="SubCellValueChange"
                            @grid-ready="onReadySub"
                            />
                    </div>
                </div>
            </div>
        </div>
        <!-- 고장증상 그리드 e.-->
        <!-- Editor s.-->
        <div class="table-area">
            <div class="table-b">
                <el-row class="demo-autocomplete" :gutter="24">
                    <el-col :span="12">
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `상담메모` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="상담메모를 작성하세요."
                        v-model="form.callMemo">
                        </el-input>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                    <el-col :span="12">
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `기타메모` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="기타메모를 작성하세요."
                        v-model="form.visitMemo">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- Editor e.-->
        <!-- AS 배정 s.-->
        <div class="table-area">
            <div class="table-b">
                <el-row class="demo-autocomplete" :gutter="24">
                    <el-col>
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `처리기사` }}</h3>
                            </div>
                        </div>
                         
                        <el-col :span="10">
                            <el-col :span="7">
                                <el-input v-model="form.userNm" readonly>
                                </el-input>
                                <el-input v-model="form.userId" v-show="false"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="primary" icon="el-icon-search" @click="openModelAtcor"></el-button>
                            </el-col>
                        </el-col>
                        <div class="btn-wrap btn-type1 clearfix">
                            <button class="btn-size btn-gray fl_left" @click="proc">
                            <span class="btn-icon">
                                <i class="fas fa-save"></i>
                            </span>
                            저장
                            </button>
                        </div>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                </el-row>
             
                <el-input v-model="form.asAgentNm" v-show="false"></el-input>
                <el-input v-model="form.userNm" v-show="false"></el-input>
                <el-input v-model="form.userId" v-show="false"></el-input>

                <el-input v-model="form.allocationDt" v-show="false"></el-input>
                <el-input v-model="form.tripGrade" v-show="false"></el-input>
                <el-input v-model="form.custNm" v-show="false"></el-input>

                <el-input v-model="form.telNo" v-show="false"></el-input>
                <el-input v-model="form.requestVisitDt" v-show="false"></el-input>
                <el-input v-model="form.requestVistHh" v-show="false"></el-input>
                <el-input v-model="form.requestVistMm" v-show="false"></el-input>
      
            </div>
        </div>
        <!-- AS 배정 e.-->
        <div class="inner-box">
            <!-- AS 접수이력 그리드 s.-->
            <div class="table-area">
                <div class="table-b">
                    <div class="table-header">
                        <div class="table-name">
                            <h3 class="ico_table_name">{{ `AS이력` }}</h3>
                        </div>
                        
                        <div class="grid-tbl-box">
                            <ag-grid-vue 
                                ref="grid" 
                                :style="gridStyle2"
                                class="ag-theme-alpine"
                                :enableRangeSelection="true"
                                :column-defs="histColumnDefs"
                                :grid-options="histGridOptions"
                                :row-data="histData"
                                :default-col-def="defaultColDef"
                                :framework-components="frameworkComponent"
                                @grid-ready="onReadyHist"
                                @cell-clicked="onHistCellClicked" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- AS 접수이력 그리드 e.-->
        </div>

    </div>
</template>


<script>
function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
// import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import NumberInputCellRender from '@/components/agGrid/numberinput-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';
import SelectCellRendererSecondary from '@/components/agGrid/select-cell-renderer-secondary';

/**
 * * Modal
 */
import AsCallTreatModal from '@/components/AS/History/Modal/ReceptionModal.vue';
import ReceptionModal from '@/components/AS/Receipt/Modal/ReceptionModal.vue';
import ModelSpec from '@/components/LucomsModal/ModelSpec.vue';
import ModelBreak from '@/components/LucomsModal/ModelBreak.vue';
import ModelActor from '@/components/LucomsModal/ModelActor.vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

const options = {};

export default {
    mixins: [slip, common],
    props: ['custParam'],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            input1: '',
            value: '1',
            options: [
                {
                    value: '1',
                    label: '서울'
                },
                {
                    value: '2',
                    label: '경기도'
                },
            ],
            combos: ['asClass3'],
            asClassOpt: [{ key: '1', value: '부산'}], /** 접수유형 */
            asClassOptId: [],   /** 접수유형 */
            subAsClassOpt: [],   /** 세부유형 */
            data: [],
            subData: [],
            histData: [],
            delChkList: [],
            delSubChkList: [],
            tripGradeList: [],  /** 출장급지 리스트 */
            requestVistHhList: [], /** 일시 : 시 */
            requestVistMmList: [], /** 일시 : 분 */
            selModelObj: {},    /** AS접수제품 클릭하여 선택된 모델 */
            guaranteeMonth: '', /** 보증개월수 */
            form: {
                custNm : '',
                custType : 'Default',
                propensity : 'Default',
                propensityBigo: '', 
                positionNm: '', 
                hpNo: '', 
                officeTelNo: '', 
                etcTelNo1: '', 
                etcTelNo2: '', 
                boundTelNo: '', 
                smsYn: 'Y', 
                telYn: '',
                addr1: '',
                addr2: '',
                zipCd: '',
                zipCd1: '',
                juminNo: '',
                callMemo: '', /** 고객요구사항 */
                visitMemo: '', /** 특이사항 */
                areaAgent: '', /** 지역ID */
                asAgentId: '', /** 처리센터 ID */
                asAgentNm: '', /** 처리센터 */
                userNm: '', /**처리기사 */
                userId: '', /**처리기사 */
                allocationDt: '', /** 배정일시 */
                tripGrade: 'X', /** 출장급지 */
                custNm: '', /** 신고자명 */
                telNo: '', /** 신고자 전화번호 */
                requestVisitDt: '', //this.$moment().format('YYYY-MM-DD'), /** 요청일시 : 처리기사 팝업에서 지정한 날짜 */
                requestVistHh: '', /** 요청일시 시간 */
                requestVistMm: '', /** 요청일시 분 */
                agMaker: '', /** 대행사 제조사 */
                agMakerCd: '', /** 대행사 제조사 */
                agMakerNm: '' /** 대행사 제조사 */
            },

            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
            gridStyle2 : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
            context: {
                // context is used as a global variable
                editorUpdateMethods: {},
                editorRefs: {},
                getRefData: this.getRefData,
            },
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            mainGridApi: null,
            mainColumnApi: null,
            subGridApi: null,
            subColumnApi: null,
            histGridApi: null,
            histColumnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            histColumnDefs: [],
            mainGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            histGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                maskEdit: MaskEditCellRenderer,
                select: SelectCellRenderer,
                checkBox: CheckboxCellRenderer,
                radio: RadioCellRenderer,
                numberInput: NumberInputCellRender,
                input: InputCellRender,
                button: ButtonCellRenderer,
                secondarySelect: SelectCellRendererSecondary,
            },
            topDownData: [],
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    mounted() {
        this.setMyCenter();
        
        this.$http.post(`/api/asMng/call/getTopDownData`, {topKey: 'AsClass'})
        .then(response => {
            this.topDownData = response.data;
        });
        
        const vAsReceipt = JSON.parse(sessionStorage.getItem("asReceipt"))
        if(vAsReceipt && vAsReceipt.loginId === this.$store.state.loginInfo.loginId){
            this.data = vAsReceipt ? vAsReceipt.modelData : [] //AS접수제품
            
        } else {
            if(vAsReceipt){
                sessionStorage.removeItem("asReceipt")      // AS접수제품 초기화
            }
        }
        
        console.log('this.subData 1: ', this.subData)
        const vAsModelBreak = JSON.parse(sessionStorage.getItem("asModelBreak"))
        console.log('mount vAsModelBreak: ', vAsModelBreak)
        
        if(vAsModelBreak && vAsModelBreak.loginId === this.$store.state.loginInfo.loginId){
            this.subData = vAsModelBreak ? vAsModelBreak.modelBreak : [] //고장증상
            
        } else {
            if(vAsModelBreak){
                sessionStorage.removeItem("asModelBreak")   // 고장증상 초기화
            }
        }

        let i = 0
        // 일시 : 시간
        for(i=9; i<=20; i++){
            const vLabel = ( (i < 10) ? '0' + i.toString() : i.toString() ) + '시';
            const vHh = {key: i.toString(), value: i.toString(), label: vLabel}
            this.requestVistHhList.push(vHh);
        }
        this.requestVistHhList.unshift({key:'', value:'', label: '선택'});

        // 일시 : 분
        for(i=0; i < 6; i++){
            let vLabel = '0' + i.toString() + '분';
            if(i>0){
                vLabel = i.toString() + '0분';
            }
            const vMm = {key: (i*10).toString(), value: (i*10).toString(), label: vLabel}
            this.requestVistMmList.push(vMm);
        }
        this.requestVistMmList.unshift({key:'', value:'', label: '선택'});

        this.setHistoryList();

        if(this.$store.state.loginInfo.groupUId === 29){
            this.getHistList();
        }

    },
    methods: {
        onReadyMain() {
            // AS접수제품 그리드 api 정의
            this.mainGridApi = this.mainGridOptions.api;
            this.mainColumnApi = this.mainGridOptions.columnApi;
            this.getGuaranteeMonth();
            this.getCombo({flag: 'INIT'});
        },
        onReadySub() { 
            // 고장증상 그리드 api 정의
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        onReadyHist() { 
            // AS이력 그리드 api 정의
            this.histGridApi = this.histGridOptions.api;
            this.histColumnApi = this.histGridOptions.columnApi;
            this.createHistColumnDefs();
        },
        getGuaranteeMonth(){
            // 보증개월수 조회  
            this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.DefaultGuaranteeMonth'}})
                    .then(response => {
                        this.guaranteeMonth = response.data[0].configValue || ''
                         console.log('this.guaranteeMonth: ', this.guaranteeMonth) 
                    });
                
        },
        async getCombo(param) {
            if(param.flag === 'INIT'){
                // 접수유형 : AsClass 2레벨
                const runA = this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AsClass'}})
                    .then(response => {
                        this.asClassOpt = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==2)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value};
                                                            })
                        ) || [];
                        this.asClassOpt.unshift({key:'', value:'선택'})                                    

                        this.combos['asClass3'] = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==3)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value};
                                                            })
                         ) || [];
                                                            
                        this.subAsClassOpt = [{key:'', value:'선택'}, {key:'a', value:'a'}, {key:'b', value:'b'}, {key:'c', value:'c'}]
                        
                        console.log('getCombo this.asClassOpt: ', this.asClassOpt)
                    });

                const runB =  this.$http.post(`/api/asMng/call/getTopDownData`, {topKey: 'AsClass'})
                    .then(response => {
                        this.topDownData = response.data;
                    });
        
                const runC = this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 89}})
                    .then(response => {
                        this.asClassOptId = response.data || []
                        this.asClassOptId.unshift({key:'', value:'선택'})
                    }); 
                    
                // 출장급지 : TripGrade 2레벨
                const runD = this.$http.get(`/api/codeMng/combo`, {params: {parentId: 305}})
                    .then(response => {
                        console.log(' 출장급지: ', response.data);
                        this.tripGradeList = response.data || [];
                        this.form.tripGrade = '무급지';
                    });
                
                this.$store.commit('loading');

                await Promise.all([runA, runB, runC, runD]);
                await this.createMainColumnDefs();

                this.$store.commit('finish');

            } else {
                 
                if(param.key === ''){
                    this.subAsClassOpt = []
                    this.subAsClassOpt.unshift({key:'', value:'선택'})
                } else {
                    console.log('getCombo sub param: ', param)
                    const vModelIdx = this.asClassOpt.findIndex(x=>x.key === param.key)
                    console.log('getCombo response.data 12: ', this.asClassOptId[vModelIdx])
                    // 세부유형 : AsClass 2레벨
                    await this.$http.get(`/api/codeMng/combo`, {params: {parentId: this.asClassOptId[vModelIdx].key}})
                        .then(response => {
                            
                            this.subAsClassOpt = response.data || []
                            this.subAsClassOpt.unshift({key:'', value:'선택'});

                            // this.$refs.grid[param.idx-1].columnDefs[11].cellRendererParams.options.length = 0;
                            
                            this.subAsClassOpt.forEach(x => {
                                this.$refs.grid[param.idx-1].columnDefs[11].cellRendererParams.options.push(x);    
                            })
                            
                            this.mainGridApi.refreshCells({ payYn: 'N' });
                            this.mainGridRefresh(param.idx);
                        });
                }
                
            }

        },
        async createMainColumnDefs() {
            const that = this;
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'제조사',
                    field:'maker', 
                    width:110,
                    hide: true,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'대표모델',
                    field:'standardModelNm', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'모델CD',
                    field:'modelCd', 
                    width:110,
                    hide: true
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:160,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width:90,
                    editable : true,
                    cellRenderer: 'numberInput',
                    cellStyle:{textAlign: 'center', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return that.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'보증만료일',
                    field:'guaranteeEndDt', 
                    width:130,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: (params) => {
                        return params.value ? that.$moment(params.value).format('YYYY-MM-DD') : '';
                    }
                },
                {
                    headerName:'구입년월',
                    field:'purchaseDt',
                    width:130,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'datePicker',
                    cellRendererParams: {
                        // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                        type: 'month',
                        format: 'yyyy-MM',  //date format
                        valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                        disable: false, //disabled 처리
                    }
                },
                {
                    headerName:'접수유형',
                    field:'asClass', 
                    width:120,
                    editable : true,
                    cellStyle:{textAlign: 'center'},
                    cellEditor: 'secondarySelect',
                    cellEditorParams: { 
                        values: that.topDownData.ROOT.map(x=>x.value), focusOnEditStart: true 
                    },
                    // cellRenderer: 'select',
                    // cellRendererParams: {
                    //     // options : options["asClassOpt"],
                    //     options : that.asClassOpt,
                    //     detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                    //     detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    // },
                    // onCellValueChanged : (params) => {
                    //     if (params.oldValue !== params.newValue) {
                    //         console.log('onCellValueChanged kkkk2: ', params)
                       
                    //     //현재 셀의 object변경시킴
                    //     /*
                    //         params.colDef.cellRendererParams.options = [{key:'', value:'선택'}, {key: params.newValue, value: params.newValue}]
                    //         params.data.subAsClass = params.newValue; // assign to new adjacent column
                    //         params.api.refreshCells({columns : ["subAsClass"]}) ;
                    //        */
 
                             
                             
                    //     }
                    // } 
                },
                {
                    headerName:'세부유형',
                    field:'subAsClass', 
                    width:120,
                    editable : true,
                    cellStyle:{textAlign: 'center'},
                    cellEditor: 'secondarySelect',
                    cellEditorParams: ({ data }) => 
                        this.getDropDownEditorParams('asClass', data, this.getRefData),
                    // cellRenderer: 'select',
                    // cellRendererParams: {
                    //     // options : options["asClassOpt"],
                    //     options : that.subAsClassOpt,
                    //     detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                    //     detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    // }
                    
                },
                {
                    headerName:'유/무상',
                    field:'payYn', 
                    width:180,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'radio',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                    }  
                },
                {
                    headerName:'보증개월수',
                    field:'guaranteeMonth', 
                    width:130,
                    hide:false
                }
            ];
        },
        createSubColumnDefs() {
            this.subColumnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName: '고장증상구분', 
                    field:'gbCd', /** 카테고리3레벨 */
                    width: 130,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '고장증상명', 
                    field:'gbNm', /** 카테고리4레벨 */
                    width: 250,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '상세증상', 
                    field:'description', 
                    width: 1130,
                    editable: true,
                    cellStyle:{textAlign:'left', backgroundColor: '#fff8f7'},
                    cellDataType: false,
                    cellRendererParams: {
                        obj: {
                            placeholder: "상세증상을 입력하세요."
                        }
                    }
                },
                {
                    headerName: 'AS_DETAIL_ID', 
                    field:'asDetailId',
                    hide: true,
                    suppressToolPanel: true
                },
                {
                    headerName: 'AS_CAT_ID', 
                    field:'asCatId',
                    hide: true,
                    suppressToolPanel: true
                },
                {
                    headerName: 'AS_CAT_IDX', 
                    field:'asCatIdx',
                    hide: true,
                    suppressToolPanel: true
                },
            ];
        },
        createHistColumnDefs() {    
            this.histColumnDefs = [
            {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                },
                {
                    headerName:'접수일자', 
                    field:'callDt', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                    cellRenderer: (params) => {
                        if(params.value && params.value.length >= 10){
                            params.value =  params.value.substring(0,10)
                        }
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {
                    headerName:'접수유형',
                    field:'asClass2Nm', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width: 210,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width: 170,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width: 80,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'증상구분',
                    field:'asCat1LvlNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'고장증상',
                    field:'asCatNm', 
                    width: 150,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'처리센터',
                    field:'allocationAsAgentNm', 
                    width: 150,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'처리결과',
                    field:'asStatusNm', 
                    width: 150,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'고객명',
                    field:'custNm', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'접수자',
                    field:'creatorNm', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'접수ID',
                    field:'asId', 
                    width: 150,
                    editable: false,
                    cellStyle:{textAlign:'center'}
                }
            ];
        },
        onMainCellClicked(params) {
            /** AS접수제품 모델선택시 */
            const idx = params.rowIndex;
            const field = params.colDef.field;
            // console.log('onMainCellClicked start ', params)
            // console.log('onMainCellClicked subData ', this.subData)

            if(field === 'modelNm') {
                this.openModelSpec(params.data);
            }

            if(params.data){
                this.selModelObj = { ...params.data, curIdx: idx}
                this.subData = params.data.subData || []
            }

            //this.setGridSessionInfo()
        },
        SubCellValueChange(params){
            /** 고장증상 셀변경시 */
            const subIdx = params.rowIndex;

            console.log('SubCellValueChange start: ', params)
            if(this.selModelObj){
                const dataIdx = this.selModelObj.curIdx
                this.data[dataIdx].subData[subIdx].description = this.subData[subIdx].description || '';
            }
            console.log('SubCellValueChange start2: ', this.data)

            // this.setGridSessionInfo()
            
        },
        // setGridSessionInfo(){
        //     // 세션정보 갱신
        //     //===========================================================
        //     sessionStorage.removeItem("asReceipt")

        //     const vAsReceipt = {
        //         modelData : this.data,
        //         loginId : this.$store.state.loginInfo.loginId
        //     } 
        //     sessionStorage.setItem("asReceipt", JSON.stringify(vAsReceipt))

        //     sessionStorage.removeItem("asModelBreak")

        //     const vAsModelBreak = {
        //         modelBreak : this.subData,
        //         loginId : this.$store.state.loginInfo.loginId
        //     } 
        //     sessionStorage.setItem("asModelBreak", JSON.stringify(vAsModelBreak))
            
        // },
        MaincellValueChange(params){
            /** AS접수제품 셀변경시 */

            const idx = params.rowIndex;
            console.log('MaincellValueChange start: ', params)
            
            /** AS접수제품 체크박스 변경시 */
            if(params.colDef.field === 'asClass'){
                // this.getCombo({flag: '', key: params.value, idx});
                console.log('subAsClassOpt aaa :', this.subAsClassOpt )
                this.subAsClassOpt=this.subAsClassOpt.filter(x=>(x.key===''||x.key==='b')) 
                console.log('this.columnDefs[idx] aaa :', this.subAsClassOpt, this.columnDefs[11])
                this.mainGridApi.redrawRows({ rowNodes: params });
            } else if(params.colDef.field === 'guaranteeEndDt'){
                //this.mainGridApi.redrawRows({ rowNodes: params });
            } else if(params.colDef.field === 'purchaseDt'){
                console.log("purchaseDt ", params)
                // params.value: YYYYMM
                const vPurchaseDt = this.$moment(params.value).format('YYYYMMDD')
                
                if(vPurchaseDt.length >= 8){
                    let date = this.$moment(vPurchaseDt).format('YYYY-MM');// new Date(Number(vPurchaseDt.substring(0,4)) , Number(vPurchaseDt.substring(4,6)), 1);
                    if(params.data.guaranteeMonth && Number(params.data.guaranteeMonth) > 0){
                        // 모델의 보증기간이 있는 경우
                        date = this.$moment(date).add(Number(params.data.guaranteeMonth), 'month').add(1, 'month').subtract(1, 'day');
                    } else {
                        // 모델의 보증기간이 없는 경우 기본 보증기간으로 계산
                        date = this.$moment(date).add((Number(this.guaranteeMonth) || 12), 'month').add(1, 'month').subtract(1, 'day');
                    }

                    let timezoneOffset = date._d.getTimezoneOffset()* 60 * 1000;
                    params.data.guaranteeEndDt = new Date(date._d.getTime() - timezoneOffset);
                    // 전화한 날짜가 보증일의 말일보다 크면 유상처리
                    let sCallDt = ''; //시스템 현재시간 조회
                    this.$http.get(`/api/asMng/call/curTime`)
                    .then(response => {
                        if(response.data && response.data.length >=10){
                            // sCallDt : YYYY-MM-DD
                            sCallDt = response.data.substring(0,10) || '';
                            
                            params.data.asClass = "AS";
                                
                            if(this.$moment(params.data.guaranteeEndDt).format('YYYYMM') < this.$moment(response.data).format('YYYYMM')){
                                params.data.payYn = "Y";
                                //params.data.subAsClass = "AB";
                                params.data.subAsClass = "유상수리";
                            } else {
                                params.data.payYn = "N";
                                //params.data.subAsClass = "AA";
                                params.data.subAsClass = "무상수리";
                            }
                        }

                        params.data.purchaseDt = vPurchaseDt; 
                        this.mainGridApi.redrawRows({ rowNodes: params });

                        
                    }); 
                    
                } else {
                    params.data.guaranteeEndDt = ""
                    params.data.payYn = "N"
                    params.data.asClass = ""
                }
                
            }

            const vAsReceipt = {
                modelData : this.data,
                loginId : this.$store.state.loginInfo.loginId
            } 
            sessionStorage.setItem("asReceipt", JSON.stringify(vAsReceipt))
        },
        
        mainGridRefresh(idx) {
            var rows = [];
            var rowNode = this.mainGridApi.getDisplayedRowAtIndex(idx);
            rows.push(rowNode);
            this.mainGridApi.redrawRows({ rowNodes: rows });
        },
        onHistCellClicked(params) {
            // AS이력 클릭시

            //const idx = params.rowIndex;
            const field = params.colDef.field;
            if(field==='callDt'){
                this.openHistModel(params.data);
            }
        },
        proc() {
            /** 하단의 저장버튼 : AS접수제품을 저장처리 */

            if(!this.$parent.$refs.refSearchForm.custValidate()){
                // searchForm의 조회조건 체크
                return false;
            }

            let vData = _.cloneDeep(this.data)
            console.log('proc start :', this.data)
            /** 체크로직 */
            if(vData.length === 0){
                this.$swal({
                    type: 'warning',
                    text: '하나 이상 AS접수제품을 등록해 주십시오.'
                });

                return false
            }
            
            let vNotExistEndDt = 'N';
            vData = vData.map(x=>{
                if(x.guaranteeEndDt){
                    let vGuaranteeEndDt = '';
                    try{
                        vGuaranteeEndDt = x.guaranteeEndDt.toISOString() || '';
                    } catch(e){
                        vGuaranteeEndDt = x.guaranteeEndDt || '';
                    }
                    
                    if(vGuaranteeEndDt.length>=10){
                        x.guaranteeEndDt = vGuaranteeEndDt.substring(0,10);
                    } else {
                        vNotExistEndDt = 'Y';
                    }
                } else {
                    vNotExistEndDt = 'Y';
                }
                
                return x;
            });

            if(vNotExistEndDt === 'Y'){
                this.$swal({
                    type: 'warning',
                    text: '구입년월을 등록해 주십시오.'
                });

                return false
            }

            const vQtyStr = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.qty || x.qty === '').map(y=>{return y.no}).join(',')
            
            if(vQtyStr && vQtyStr.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vQtyStr + '번 AS접수제품의 대수를 정확하게 입력해 주십시오.'
                });

                return false
            }

            const vQtyZeroStr = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>x.qty <= 0).map(y=>{return y.no}).join(',')
            if(vQtyZeroStr && vQtyZeroStr.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vQtyZeroStr + '번 AS접수제품의 대수에 1개 이상의 값을 입력해 주십시오.'
                });

                return false
            }

            const vOldPurchaseDt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>x.purchaseDt && x.purchaseDt.length >= 8 && x.purchaseDt < '19700101').map(y=>{return y.no}).join(',');
            if(vOldPurchaseDt && vOldPurchaseDt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vOldPurchaseDt + '번 AS접수제품의 구입년월을 1970년 이후로 선택해 주십시오.'
                });

                return false
            }

            const vPurchaseDt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.purchaseDt || x.purchaseDt.length < 8).map(y=>{return y.no}).join(',')
            if(vPurchaseDt && vPurchaseDt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vPurchaseDt + '번 AS접수제품의 구입년월을 선택해 주십시오.'
                });

                return false
            }

            const vAsClass = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.asClass || x.asClass==='').map(y=>{return y.no}).join(',')
            if(vAsClass && vAsClass.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vAsClass + '번 AS접수제품의 접수유형을 선택해 주십시오.'
                });

                return false
            }

            

            const vBreakCnt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.subData).map(y=>{return y.no}).join(',')
            if(vBreakCnt && vBreakCnt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vBreakCnt + '번 AS접수제품의 고장증상을 등록해 주십시오.'
                });

                return false
            }

            if(!this.form.userId || this.form.userId === ''){
                this.$swal({
                    type: 'warning',
                    text: '처리기사를 선택해 주십시오.'
                });

                return false
            }
  

            const vTripGradeCd = this.tripGradeList.filter(x=>x.value === this.form.tripGrade).map(x=>{return x.key || ''}); 
            // console.log('vTripGradeCd : ', this.form.tripGrade, this.tripGradeList, vTripGradeCd);
            const vTripGradeCd2 = vTripGradeCd && vTripGradeCd.length>0 ? vTripGradeCd[0] : '';
            // console.log('vData before : ', vData);

            const vChgData = vData.map(x=>{
                const vGuaranteeStartDt = x.guaranteeStartDt && x.guaranteeStartDt.length == 6 ? x.guaranteeStartDt.substring(0,4) + '-' + x.guaranteeStartDt.substring(4) + '-01 00:00:00' : '1900-01-01 00:00:00';
                const vGuaranteeEndDt = x.guaranteeEndDt && x.guaranteeEndDt.length == 10 ? x.guaranteeEndDt + ' 00:00:00' : '1900-01-01 00:00:00';
                const vPurchaseDt = x.purchaseDt && x.purchaseDt.length == 8 ? x.purchaseDt.substring(0,4) + '-' + x.purchaseDt.substring(4,6) + '-' + x.purchaseDt.substring(6) + ' 00:00:00' : '1900-01-01 00:00:00';
                // console.log('vGuaranteeEndDt: ', x.guaranteeEndDt, vGuaranteeEndDt);
                // console.log('vPurchaseDt: ', x.purchaseDt, vPurchaseDt);
                x.guaranteeStartDt= vGuaranteeStartDt;
                x.guaranteeEndDt = vGuaranteeEndDt;
                x.purchaseDt = vPurchaseDt;
                x.prodDt = x.prodDt ? x.prodDt + ' 00:00:00' : '1900-01-01 00:00:00';
                x.payYn = x.payYn ? x.payYn : 'Y';
                x.serialNo = x.serialNo ? x.serialNo : '';

                const vAsClassObj = this.asClassOpt.filter(y=>y.key===x.asClass || y.value===x.asClass);
                if(vAsClassObj && vAsClassObj.length>0){
                    x.asClass = vAsClassObj[0].key;
                }

                const vSubAsClassObj = this.combos['asClass3'].filter(y=>y.key===x.subAsClass || y.value===x.subAsClass);
                if(vSubAsClassObj && vSubAsClassObj.length>0){
                    x.subAsClass = vSubAsClassObj[0].key;
                }

                x.subData.map(y=>{
                    if(!y.description){
                        y.description = '';
                    }
                    
                    return y;
                })

                return x;
            })

            // console.log('vData after : ', vChgData)
            const vRequestVistHh = this.form.requestVistHh.length === 1 ? '0' + this.form.requestVistHh : this.form.requestVistHh;
            const vRrequestVistMm = this.form.requestVistMm.length === 1 ? '0' + this.form.requestVistMm : this.form.requestVistMm;
            
            const vCurDt = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            let vRequestVisitDt = vCurDt;
            if(this.form.requestVisitDt != '' && vRequestVistHh != '' && vRrequestVistMm != ''){
                vRequestVisitDt = this.form.requestVisitDt + ' ' + vRequestVistHh + ':' + vRrequestVistMm+ ':00'|| '';
            }

            if(vRequestVisitDt < vCurDt){
                this.$swal({
                    type: 'warning',
                    text: vAsClass + '현재시간 이후로 선택해 주세요.'
                });

                return false;
            }

            let vTelNo = this.form.telNo === '' ? this.form.boundTelNo || '' : '';
            vTelNo = this.form.telNo === '' ? this.form.hpNo || '' : '';
            vTelNo = this.form.telNo === '' ? this.form.custTelNo || '' : '';

            let vCallDt = this.$parent.search.callDt || '';
            if(vCallDt && vCallDt.length==16){
                vCallDt = vCallDt + ':00'; 
            } else {
                vCallDt = this.$moment().format('YYYY-MM-DD HH:mm:ss'); /** 통화일시 */
            }
            
            if(this.form.custNm ===''){
                this.form.custNm = this.$parent.search.custNm || '';
            }

            if(this.form.addr1 ===''){
                this.form.addr1 = this.$parent.search.addr1 || '';
            }

            if(this.form.addr2 ===''){
                this.form.addr2 = this.$parent.search.addr2|| '';
            }

            if(this.form.zipCd1 ===''){
                this.form.zipCd = this.$parent.search.zipCd1 || '';
                this.form.zipCd1 = this.$parent.search.zipCd1 || '';
            }

            if(this.form.telNo ===''){
                this.form.telNo = this.$parent.search.telNo|| '';
            }

            if(this.form.hpNo ===''){
                this.form.hpNo = this.$parent.search.hpNo|| '';
            }

            if(this.form.boundTelNo ===''){
                this.form.boundTelNo = this.$parent.search.boundTelNo|| '';
            }

            let vSaveform0 ={
                ...this.form,
                custNm: this.$parent.search.custNm || '', /** 조회조건 */
                custId: this.$parent.search.custId || '', /** 조회조건 */
                boundCustNm: this.form.custNm || '', /** 신고자명 */
                custGb: '1', /** 조회조건 */
                codeNm: '', /** 조회조건 */
                useType: 'Y', /** 조회조건 */
                inType: this.$parent.search.inType || '', /** 조회조건 */
                inTypeVal: this.$parent.search.inTypeVal || '', /** 조회조건 */
                callDt: vCallDt,
                actTab: 'AS_TAB', /** 활성탭 */
                boundId:'0',
                allocationAsAgentId: this.form.asAgentId || '0',
                allocationRepairId: this.form.userId || '0',
                requestVisitDt : vRequestVisitDt,
                tripGrade : vTripGradeCd2,
                asData : vChgData
            }

            vSaveform0 = JSON.parse(JSON.stringify(vSaveform0));
            
            const vvTelNo = vSaveform0.telNo || '';
            const vvHpNo = vSaveform0.hpNo || '';
            const vvBoundTelNo = vSaveform0.boundTelNo || '';

            vSaveform0 = {
                ...vSaveform0,
                telNo: vvTelNo,
                hpNo: vvHpNo,
                boundTelNo: vvBoundTelNo,
                workInYn: 'Y'
            }
            const vSaveform = vSaveform0;

            const regex = /[^0-9]/g
            vSaveform.telNo = vSaveform.telNo.replace(regex, '');
            vSaveform.boundTelNo = vSaveform.boundTelNo.replace(regex, '');
            vSaveform.hpNo = vSaveform.hpNo.replace(regex, '');
            
            if(this.$store.state.loginInfo.groupUId == '5' || this.$store.state.loginInfo.groupUId == '6'){
                vSaveform.boundType = 'AT'; // 지정점 접수
            } else {
                vSaveform.boundType = 'BT'; // 콜센터접수 접수
            }
            
            console.log('vSaveform : ', vSaveform);

            this.$swal({
                type: 'warning',
                text: `AS내역을 저장 하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading');
                    this.$http.put('/api/asMng/call/saveCallAs', vSaveform, {timeout: 60000*30})
                        .then(response => {
                            sessionStorage.removeItem("asModelBreak");
                            sessionStorage.removeItem("asReceipt");
                            this.data  = [];
                            this.subData = [];
                            
                            this.$swal({ type: 'success', text: 'AS내역이 저장되었습니다' });
                            
                            // 재로딩
                            this.$router.go(this.$router.currentRoute);
                            
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: 'AS내역의 저장에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$parent.$parent.openTodoListModal();
                            this.$store.commit('finish');
                        });

                }
            });
        },
        /**
         * AS 팝업 오픈
         * * AS접수 제품 모델 선택 팝업
         */
        openModel() {
            let vm = this;
            // console.log('$parent SearchForm:', this.$parent)
            this.$modal.open({
                width: 800,
                component: ReceptionModal,
                parent: this,
                props: {
                    data: [{'param': this.$parent.search}],
                    agMaker: this.form.agMaker,
                    agMakerCd: this.form.agMakerCd,
                    agMakerNm: this.form.agMakerNm
                },
                events: {
                    close(param) {
                        // console.log('openModel close', param.data, vm);
                        if(param.data){
                            vm.data = vm.data ? vm.data : [];
                            const  vData = {
                                ...param.data,
                                qty: 1
                            }
                            console.log('vm.data : ', vm.data);
                            vm.data.push(vData);
                        }
                        
                        // const vAsReceipt = {
                        //     modelData : vm.data,
                        //     loginId : vm.$store.state.loginInfo.loginId
                        // } 
                        // sessionStorage.setItem("asReceipt", JSON.stringify(vAsReceipt));

                        var rowNode = vm.mainGridApi.getDisplayedRowAtIndex(vm.data.length-1);
                        if(param.data){
                            vm.selModelObj = { ...rowNode, curIdx: vm.data.length-1};
                            vm.subData = [];
                        }

                        //vm.setGridSessionInfo();
                        // console.log('vm store: ', vm)
                    },
                }
            });
        },
        /**
         * 처리기사 팝업 오픈
         */
        openModelAtcor() {
            const vm = this;
            let vSumQty = 0;
            this.data.map(x=>{
                if(x.qty && x.qty != ''){
                    vSumQty += Number(x.qty);
                }
                return x;
            });

            const vSrchObj = this.$parent.search;
            const vForm = {
                            addr1 : vSrchObj.addr1 || '',
                            addr2 : vSrchObj.addr2 || '',
                            areaAgent : (vm.form.areaAgent ? vm.form.areaAgent : vSrchObj.areaAgent) || '', /** 지역 ID*/
                            asAgentId : (vm.form.asAgentId ? vm.form.asAgentId : vSrchObj.asAgentId) || '' , /** 센터ID */
                            repairId : (vm.form.userId ? vm.form.userId : vSrchObj.userId) || '' ,
                            modelCnt : vSumQty
                        };
console.log('openModelAtcor vSrchObj: ', vSrchObj, vForm);
            this.$modal.open({
                component: ModelActor,
                parent: vm,
                width: 1000,
                props: {
                    data: vForm,
                },
                events: {
                    close(retData) {
                        console.log('openModelAtcor close', retData);
                        const data = _.cloneDeep(retData);
                        vm.form.areaAgent = data.areaAgent /** 지역 ID */
                        vm.form.asAgentId = data.asAgentId /** 처리센터 ID */
                        vm.form.asAgentNm = data.asAgentNm
                        vm.form.userId = data.userId /**처리기사 */
                        vm.form.userNm = data.userNm /**처리기사 */
                        
                        if(data.selField === ''){
                            vm.form.requestVisitDt = undefined;
                            vm.form.requestVistHh = '';
                            vm.form.requestVistMm = '';
                        } else {
                            if(data.selField === 'toMorn' || data.selField === 'toAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(1, 'day').format('YYYY-MM-DD'); /** 익일 */
                            } else if(data.selField === 'dotMorn' || data.selField === 'dotAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(2, 'day').format('YYYY-MM-DD'); /** 익익일 */
                            } else {
                                vm.form.requestVisitDt = vm.$moment().format('YYYY-MM-DD'); /** 당일 */
                            }

                            // 일시 셋팅
                            vm.form.requestVistMm = '0'; /** 요청일시 분 */
                            if(data.selField === 'after' || data.selField === 'toAfter' || data.selField === 'dotAfter') {
                                vm.form.requestVistHh = '13';  /** 요청일시 시간 : 오후 */
                            } else {
                                vm.form.requestVistHh = '9';  /** 요청일시 시간 : 오전 */
                            }
                        }
                        
                    },
                }
            });
        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
        openModelSpec(param) {
            
            const vForm = {
                modelGroup: param.modelGroup,
                modelCd : param.modelCd
            };

            this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});

        },
        /**
         * 고장증상 팝업 오픈
         * * AS접수 제품 모델 그리드 추가 이후 생성되어지는 고장증상 추가 버튼 클릭 오픈 팝업
         */
        breakOpenModal() {
            let vSrcObj = this.data
            
            if(!vSrcObj){
                this.$swal({
                type: 'warning',
                text: 'AS접수제품에서 선택된 행이 없습니다..'
                });

                return false
            } else if (vSrcObj.length === 1){
                // AS접수제품을 클릭안했더라도 한건뿐이면 강제로 선택시켜서 breakOpenModal 호출시킴.
                this.selModelObj =  { ...vSrcObj[0], curIdx: 0}
            }

            let vm = this;
            if(this.selModelObj.modelNm){
                const vSelModelObj = this.selModelObj
                this.$modal.open({
                    component: ModelBreak,
                    parent: this,
                    props: {
                        data: {
                            selModelObj: vSelModelObj
                        },
                    },
                    events: {
                        close(param) {
                            console.log('close', param);
                            console.log('close vm.subData: ', vm.subData);
                            if(param.data){
                                vm.subData = vm.subData ? vm.subData : []

                                param.data.forEach(x => {
                                    vm.subData.push(x)
                                })
                            }
                            
                            console.log('close vm.subData2: ', vm.subData);

                            // 선택된 AS접수제품에 subData을 맵핑
                            vm.subData.modelId = vm.data[vSelModelObj.curIdx].modelId || ''
                            vm.data[vSelModelObj.curIdx].subData = vm.subData
                            
                            // const vAsReceipt = {
                            //     modelData : vm.data,
                            //     loginId : vm.$store.state.loginInfo.loginId
                            // } 
                            // sessionStorage.setItem("asReceipt", JSON.stringify(vAsReceipt))
                            
                        },
                    }
                });
            } else {
                this.$swal({
                    type: 'warning',
                    text: 'AS접수제품에서 선택된 행이 없습니다.'
                    });
            }
            
        },
        deleteRow(vflag){ 
            let vSrcObj = this.data;
            
            if(vflag === 2){
                vSrcObj = this.subData;
            }

            let chkedObj = vSrcObj.filter(x=>x.chk==='Y');

            if(!vSrcObj || chkedObj.length === 0){
                this.$swal({
                type: 'warning',
                text: '선택된 행이 없습니다.'
                });

                return false;
            }

            const vLiveObj = vSrcObj.filter(x=>x.chk!='Y');
            vSrcObj = vLiveObj;

            if(vflag === 1){
                this.data = vLiveObj;

                // sessionStorage.removeItem("asReceipt");

                // const vAsReceipt = {
                //     modelData : vLiveObj,
                //     loginId : this.$store.state.loginInfo.loginId
                // } 
                // sessionStorage.setItem("asReceipt", JSON.stringify(vAsReceipt));

                // 선택된data 를 초기화후 0번째 셋팅                
                this.selModelObj = {}
                if(this.data && this.data.length>0){
                    this.selModelObj =  { ...this.data[0], curIdx: 0};
                    this.subData = this.data[0].subData || [];
                    this.data.map(x=>{x.chk='N'});
                    this.data[0].chk = 'Y';
                } else {
                    this.subData = [];
                    //sessionStorage.removeItem("asModelBreak")
                }
                
                
            } else {
                this.subData = vLiveObj

                // sessionStorage.removeItem("asModelBreak")

                // const vAsModelBreak = {
                //     modelBreak : vLiveObj,
                //     loginId : this.$store.state.loginInfo.loginId
                // } 
                // console.log('vAsModelBreak : ', vAsModelBreak)
                // sessionStorage.setItem("asModelBreak", JSON.stringify(vAsModelBreak))
                 
                if(this.selModelObj){
                    const dataIdx = this.selModelObj.curIdx
                    this.data[dataIdx].subData = vLiveObj
                }
                
            }

        },
        getDropDownEditorParams(parentColumn, data, getRefData) {
            const parentCellValue = data[parentColumn];
            return {
                // the editor is provided with initial options for the select editor
                values: this.getRefData(parentCellValue),
                // and parent column name / colId
                cascadeFrom: parentColumn,
            };
        },
        getRefData(refKey) {
            const key = refKey || this.topDownData.ROOT[0].value;
            const refData = this.topDownData[this.topDownData.ROOT.filter(x=>x.value === key).map(x=>x.key)[0]].map(x=>x.value);
            return refData;
        },
        setHistoryList(param) {
            console.log('setHistoryList start: ', this.custParam.callAsCustSelPageList)
            //this.data = []
            //Object.assign(this.data, this.custParam.callAsCustSelPageList);
            //console.log('setHistoryList start this.data: ', this.data)

            let catObj = this.custParam.getCatDataByParent
            let histObj = param
            if(!param){
                histObj = this.custParam.callAsCustSelPageList || []
            }

            console.log('setHistoryList histObj: ', histObj)
            
            // 조회목록에서 코드를 명칭으로 변환처리
            histObj.map((x, i) => {

                if(x.asParentClassNm === ''){
                    x.asClass2Nm = x.asClassNm;
                }else {
                    x.asClass2Nm = x.asParentClassNm + '/' + x.asClassNm;
                }
                
                const str = x.asCatFullNm
                if (typeof str === 'string') {
                    const arr1 = str.split('>');
                    if(arr1){
                        x.asCat1LvlNm = arr1[1] || '';   // 증상구분
                    } 
                }

                if(catObj){
                    let asStatusObj = catObj.filter(y => y.topKey === 'AsStatus' 
                                                            && y.catKey === x.asStatus) || [];

                    if(asStatusObj && asStatusObj.length>0){
                        x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                    }
                }
                
                return x;
            })

  
            this.histData = histObj || []
        },
        /**
         * 접수/처리 상세 팝업 오픈
         */
         openHistModel(param) {
            if(this.$store.state.loginInfo.groupUId === 29){
                this.custParam.popHeadInfo = {};
            }

            let vm = this;
            this.$modal.open({
                width: 800,
                component: AsCallTreatModal,
                parent: this,
                props: {
                    data: {
                        asId: param.asId,
                        custId: param.custId,
                        sortType: '',
                        popHeadInfo: this.custParam.popHeadInfo,
                        //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
                        recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
                        procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        setMyCenter(){
            // 로그인한 기사센터 셋팅

            const vm = this;

            const vform = {
                companyId: this.$store.state.loginInfo.compCd, 
                parentId: '217',
                child1: this.$store.state.loginInfo.asAgentId,
                child1Col: 'C',
                child2: '',
                child3: '',
                searchFlag: (this.$store.state.loginInfo.asAgentId && this.$store.state.loginInfo.asAgentId != '') ? "AS_USER" : ''
            }

            if(this.$store.state.loginInfo.asAgentId != ''){
                this.$http.get(`/api/asMng/call/combo`, {params: vform})
                .then(response => {
                    const respCombo = response.data.getComboList
                    const respAsuser = response.data.getAsUserList || []

                    // 센터명 리스트
                    let vAsAgentIds = [];
                    vAsAgentIds = respCombo.filter(x=>x.pcFlag==='C1')
                        .map(y=>{
                            y.key = y.catId
                            y.value = y.catId
                            y.label = '[' + y.catKey + ']' + y.catNm
                            return y
                        }) || [];
                        
                    vm.form.areaAgent = vAsAgentIds[0] ? vAsAgentIds[0].parentId : ''; // 지역 설정
                    vm.form.asAgentId =  vm.$store.state.loginInfo.asAgentId+''; /** 처리센터 ID */

                    if(vm.$store.state.loginInfo.groupUId == 29){
                        // 대행사는 AS기사가 아니어서 공백처리
                        vm.form.userNm =  ''; /**처리기사 */
                        vm.form.userId =  ''; /**처리기사 */
                    } else {
                        vm.form.userNm =  vm.$store.state.loginInfo.userName; /**처리기사 */
                        vm.form.userId =  vm.$store.state.loginInfo.id+''; /**처리기사 */
                    }
                    
                });
            }
            
        },
        /**
         * 접수이력 조회
         */
        async getHistList(){
            let vm = this;
            let vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                custId: '0',
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }

            console.log('getHistList vform : ', vform) ;
            
            this.$store.commit('loading');

            await this.$http.post(("/api/asMng/call/selectAgMaker"), vform
                ).then(response => {
                    console.log(' selectAgMaker data : ', response.data);
                     
                    const userMap = response.data;
                    if(userMap) {
                        this.form.agMaker = userMap.agMaker;
                        this.form.agMakerCd = userMap.agMakerCd;
                        this.form.agMakerNm = userMap.agMakerNm;
                    }

                }).finally(() => {});

            await this.$http.post(("/api/asMng/call/selectAsCustSelPage"), vform
                ).then(response => {
                    console.log(' selectAsCustSelPage data : ', response.data);
                    let catObj = response.data.getAsStatus;
                    
                    this.histData = response.data.selectAgHistoryList
                        .map(x=>{
                            
                            const str = x.asCatFullNm
                            if (typeof str === 'string') {
                                const arr1 = str.split('>');
                                if(arr1){
                                    x.asCat1LvlNm = arr1[1] || '';   // 증상구분
                                } 
                            }
                            
                            if(x.asParentClassNm === ''){
                                x.asClass2Nm = x.asClassNm;
                            }else {
                                x.asClass2Nm = x.asParentClassNm + '/' + x.asClassNm;
                            }
                            
                            if(catObj){
                                let asStatusObj = catObj.filter(y => y.catLvl==3 && y.catKey === x.asStatus) || [];
                                if(asStatusObj && asStatusObj.length>0){
                                    x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                                } else {
                                    asStatusObj = catObj.filter(y => y.catLvl==2 && y.catKey === x.asStatus) || [];
                                    if(asStatusObj && asStatusObj.length>0){
                                        x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                                    }
                                }
                            }

                            return x;
                        });

                }).finally(() => {
                this.$store.commit('finish');
            });
        },

    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>